export default "__VITE_ASSET__DcM0eXsH__"